import { Button, Checkbox, Grid, Stack } from '@mui/material';
import TermsDialog from '../../Dialog/TermsDialog';
import { IFormController } from '../types';
import React from 'react';

const CheckBoxTerms = (props: IFormController) => {
  const { label } = props;
  const [checked, setChecked] = React.useState(false);
  const [termsOpen, setTermsOpen] = React.useState<boolean>(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.formik?.setFieldValue(props.name, event.target.checked);
    setChecked(event.target.checked);
  };

  const handleClickOpen = () => {
    setTermsOpen(true);
  };
  
  return (
    <Grid>
      <Stack direction='row'>
        <Checkbox 
          checked={checked}
          onChange={handleCheckboxChange}/>
        <Button onClick={handleClickOpen}>{label}</Button>
        <TermsDialog open={termsOpen} handleClose={() => setTermsOpen(false)}
          onAccept={() => {
            props.formik?.setFieldValue(props.name, true);
            setTermsOpen(false);
            setChecked(true);
          }}
          onDecline={()=> {
            setChecked(false);
            props.formik?.setFieldValue(props.name, false);
          }}/>
      </Stack>
    </Grid>
  );
};

export default CheckBoxTerms;